export const filterOption = (input: string, { label }: { label?: unknown }): boolean =>
  (typeof label === 'string' || typeof label === 'number') &&
  label.toString().toLocaleLowerCase().includes(input.toLocaleLowerCase());
